<template>
  <div class="m-joinUs-page">
    <div class="panel-filter" :class="{'showSel': showSel}">
      <div class="panel-selected">
        <span class="cond-item"
              @click="showConds('sort')"
              :class="{'open': selected.type=='sort'}">
          {{selectedLabel.sort}} <em class="i-op"></em>
        </span>
        <span class="cond-item"
              @click="showConds('place')"
              :class="{'open': selected.type=='place'}">
          {{selectedLabel.place}} <em class="i-op"></em>
        </span>
        <span class="cond-item"
              @click="showConds('post')"
              :class="{'open': selected.type=='post'}">
          {{selectedLabel.post}} <em class="i-op"></em>
        </span>
      </div>
      <div class="panel-conds">
        <h3>{{currentTil}}</h3>
        <div class="btn-ctner">
          <button class="c-button"
                  :class="{'active': selected[selected.type] == ''}"
                  @click="toggleCond(null)">不限</button>
          <button class="c-button"
                  :class="{'active': selected[selected.type] == item.id}"
                  @click="toggleCond(item)"
                  v-for="(item, index) in currentCond"
                  :key="index">{{item.name}}</button>
        </div>
      </div>
      <div class="panel-btns">
        <div class="cancle" @click="cancleSel">取消</div>
        <div class="confirm" @click="confirmSel">确定</div>
      </div>
    </div>

    <div class="join-us-container">
      <ul class="recruit-list" v-if="jobs.length > 0">
        <li v-for="(item, index) in jobs"
            :key="index">
          <router-link :to="{name: 'mJoinDetail', params: {data: item}}">
            <h3>
              {{item.post}}
              <em class="salary">{{item.salary}}</em>
            </h3>
            <p class="j-addition">
              <span>{{item.place}}</span>
            </p>
            <p>
              <time>{{item.gmtPublish}}</time>
            </p>
          </router-link>
        </li>
      </ul>
      <button class="more-news"
              ref="loadTag"
              v-show="hasMore">
        <em class="i-fresh"></em>上划查看更多
      </button>
      <button class="more-news"
              v-show="!hasMore">
        没有更多了
      </button>
    </div>
  </div>
</template>

<script>
  import fetch from '../server/index';
  import ScrollLoad from '../components/scrollLoad.js';

  export default {
    data () {
      return {
        dictory: {
          place: [],
          post: [],
          sort: [{
            id: 1,
            name: '最早发布'
          }, {
            id: 2,
            name: '最晚发布'
          }]
        },
        selectedLabel: {
          sort: '顺序',
          place: '地区',
          post: '岗位'
        },
//        选中筛选条件
        selected: {
          type: 'places',
          place: '',
          post: '',
          sort: '',
          pageNumber: 1,
          pageSize: 10
        },
        showSel: false,
        jobs: [],
        hasMore: true
      }
    },
    computed: {
      currentCond () {
        return this.dictory[this.selected.type];
      },
      currentTil () {
        if (this.selected.type === 'place') {
          return '工作地点';
        }
        if (this.selected.type === 'post') {
          return '工作岗位';
        }
        if (this.selected.type === 'sort') {
          return '排序条件';
        }
        return 'error';
      }
    },
    methods: {
      toggleCond (item) {
        this.selected[this.selected.type] = item ? item.id : '';
        if (this.selected.type === 'place') {
          this.selectedLabel.place = item ? item.name : '不限地区';
        }
        if (this.selected.type === 'post') {
          this.selectedLabel.post = item ? item.name : '不限岗位';
        }
        if (this.selected.type === 'sort') {
          this.selectedLabel.sort = item ? item.name : '不限顺序';
        }
      },
      showConds (t) {
        this.showSel = true;
        this.selected.type = t;
      },
      cancleSel () {
        this.selected.type = '';
        this.showSel = false;
      },
      confirmSel () {
        this.selected.type = '';
        this.showSel = false;
        this.getPosts();
      },
      sortBy: function (attr, rev) {
        // 第二个参数没有传递 默认升序排列
        if (rev === undefined) {
          rev = 1;
        } else {
          rev = (rev) ? 1 : -1;
        }

        return function (a, b) {
          a = a[attr];
          b = b[attr];
          if (a < b) {
            return rev * -1;
          }
          if (a > b) {
            return rev * 1;
          }
          return 0;
        }
      },
      sortJobs () {
        if (this.selected.sort === 1) {
//          最早发布
          this.jobs.sort(this.sortBy('gmtPublish', true));
        } else if (this.selected.sort === 2) {
//          最晚发布
          this.jobs.sort(this.sortBy('gmtPublish'));
        }
      },
      getConditons () {
//        地区获取
        fetch('/api/recruit/places').then(res => {
          this.dictory.place = res;
        }, err => {
          console.log(err)
        }).catch(e => {
        })
//        职位获取
        fetch('/api/recruit/posts').then(res => {
          this.dictory.post = res;
        }, err => {
          console.log(err)
        }).catch(e => {
        })
      },
      getPosts () {
//        职位列表筛选结果
        fetch('/api/recruit/list', this.selected).then(res => {
          this.jobs = res.rows || [];
          this.sortJobs();
          if (res.total >= this.jobs.length) {
            this.hasMore = false;
          } else {
            this.hasMore = true;
          }
        }, err => {
          console.log(err);
        }).catch(e => {
        });

//        滚动到顶部
        try {
          document.getElementById('scroller').scrollTop = 0;
        } catch (e) {
          console.log(e);
        }
      }
    },
    components: { },
    created () {
      this.getConditons()
      this.getPosts()

      ScrollLoad.init(document.getElementById('scroller'),
        this.$refs.loadTag,
        this.getPosts,
        this);
    }
  }
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';

  .m-joinUs-page {
    $theme-color: #00ccff;
    background: #f5f5f5;
    width: 100%;
    min-height: 80%;

    /*筛选框*/
    .panel-filter{
      background: rgba(0, 0, 0, .4);
      position: fixed;
      z-index: 60;
      top: .88rem;
      width: 100%;
      height: .87rem;
      overflow: hidden;
      &.showSel {
        height: 100%;
      }

      .panel-selected{
        height: .87rem;
        background: #fff;
        border-bottom: 1px solid #e5e5e5;
        padding: .22rem .30rem;
        font-size: .28rem;
        color: #878686;
        display: flex;
        .cond-item{
          font-size: inherit;
          width: 50%;
          text-align: center;
          border-right: 1px solid #e5e5e5;
          &.open{
            color: #00ccff;
            .i-op{
              background-image: url('../assets/images/m-s-o.png');
            }
          }
          .i-op{
            display: inline-block;
            width: .16rem;
            height: .16rem;
            background: url('../assets/images/m-s.png') no-repeat center center;
          }
          &:last-child{
            border: 0;
          }
        }
      }
      .panel-conds{
        background: #f6f6f6;
        padding: .20rem .50rem;
        min-height: 30%;
        h3{
          font-size: .30rem;
          color: #484848;
          margin-top: .30rem;
          margin-bottom: .30rem;
        }
        .btn-ctner{
          margin-left: -.18rem;
          margin-right: -.18rem;
        }
        .c-button{
          background: #ffffff;
          border: 1px solid #878787;
          border-radius: 4px;
          font-size: .28rem;
          color: #878787;
          line-height: .58rem;
          padding-left: .35rem;
          padding-right: .35rem;
          margin-left: .18rem;
          margin-right: .18rem;
          margin-bottom: .28rem;
          &.active{
            color: #fff;
            background: #00ccff;
            border-color: #00ccff;
          }
        }
      }
      .panel-btns{
        display: flex;
        div{
          width: 50%;
          line-height: .90rem;
          background: #fff;
          text-align: center;
          font-size: .32rem;
          color: #878787;
          &.confirm{
            color: #fff;
            background: #00ccff;
          }
        }
      }
    }

    /*职位列表*/
    .join-us-container{
      margin-top: .88rem;
      .recruit-list{
        li{
          padding: .40rem .50rem;
          background-color: #fff;
          margin-bottom: .20rem;
          &:last-child{
            margin-bottom: 0;
          }
          h3{
            font-size: .34rem;
            color: #3b3b3b;
            font-weight: lighter;
            margin-bottom: .32rem;
            .salary{
              float: right;
              font-size: .30rem;
              color: #ea3e3e;
            }
          }
          .j-addition {
            margin-bottom: .25rem;
            span{
              font-size: .24rem;
              color: #878787;
              border-left: 1px solid #e5e5e5;
              padding-left: .20rem;
              padding-right: .20rem;
              &:first-child{
                padding-left: 0;
                border-left: 0;
              }
            }
          }
          time{
            display: inline-block;
            font-size: .22rem;
            color: #c6c6c6;
            line-height: .34rem;
            padding: 0 .15rem;
            background: #f5f5f5;
            border-radius: 4px;
          }
        }
      }
    }

    .more-news{
      display: block;
      width: 100%;
      text-align: center;
      background: #f3f3f3;
      border: 0;
      font-size: .26rem;
      color: #c5c5c5;
      line-height: .62rem;
      vertical-align: middle;
      .i-fresh{
        display: inline-block;
        width: .33rem;
        height: .33rem;
        position: relative;
        top: .05rem;
        margin-right: .28rem;
        background: url('../assets/images/i-more-g.png') no-repeat center center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/mobile/JoinUs.vue